module.exports = __webpack_public_path__ + "static/media/StartupStation.03f3030f.jpg";